import React from 'react';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';

import { InfoField, ChipBox } from '@occc/ui-design-system';
import { EarningMechanismTransactionDiscountFragment } from '@occc/graphql';

interface ITransactionDiscountProps {
  earningMechanism: EarningMechanismTransactionDiscountFragment;
}
const formatPurchaseAmountThreshold = ({
  purchaseAmountThreshold,
}: {
  purchaseAmountThreshold: EarningMechanismTransactionDiscountFragment['purchaseAmountThreshold'];
}): string => `${purchaseAmountThreshold}`;

export const TransactionDiscount: React.FC<ITransactionDiscountProps> = ({ earningMechanism }) => {
  const navigate = useNavigate();
  const onChipClick = React.useCallback(
    (pgId: string) => {
      navigate(`/product-groups/${pgId}`);
    },
    [navigate],
  );

  return (
    <Grid container spacing={2}>
      <Grid item sm={3}>
        <InfoField
          disableTypography
          label='Excluded Product Groups'
          value={
            <ChipBox
              items={earningMechanism.ineligibleProductGroups}
              onClick={onChipClick}
              mt={0}
            />
          }
        />
      </Grid>
      <Grid item sm={3}>
        <InfoField
          label='Purchase Amount Threshold'
          value={formatPurchaseAmountThreshold(earningMechanism)}
        />
      </Grid>
    </Grid>
  );
};
